<template>
  <div>
    <v-card>
      <v-card-title v-if="this.formaction == 'create'">
        <span class="headline">Add Menu</span>
      </v-card-title>
      <v-card-title v-if="this.formaction == 'edit'">
        <span class="headline">Edit Menu</span>
      </v-card-title>

      <v-card-text>
        <small>*indicates required field</small>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                v-model="Form.alias"
                v-validate="'required|max:50'"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.alias')"
                hide-details
                :counter="50"
                label="Alias*"
                name="alias"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="Form.icon"
                :items="lookupList('icons')"
                item-value="icon"
                label="Icon"
                name="icon"
              >
                <template slot="item" slot-scope="data">
                  <v-icon>{{ data.item.value }}</v-icon>
                  &nbsp;&nbsp;{{ data.item.text }}
                </template>
                <template slot="selection" slot-scope="data">
                  <v-icon>{{ data.item.value }}</v-icon>
                  &nbsp;&nbsp;{{ data.item.text }}
                </template>
              </v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.order"
                v-validate="'required'"
                label="Order*"
                name="order"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.order')"
                hide-details
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.path"
                v-validate="'required'"
                label="Path*"
                hint="Leave blank for dropdown menu"
                name="path"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.path')"
                hide-details
              />
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.menu"
                v-validate="'required'"
                :items="lookupList('menu')"
                item-text="text"
                item-value="value"
                label="Menu*"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.menu')"
                hide-details
                name="menu"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                v-validate="'required'"
                v-model="Form.menuLevel"
                :items="lookupList('menulevel')"
                label="Menu Level*"
                name="menuLevel"
                item-text="text"
                item-value="value"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.menuLevel')"
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.menuAction"
                v-validate="'required'"
                :items="lookupList('menuaction')"
                item-text="text"
                item-value="value"
                label="Menu Action*"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.menuAction')"
                hide-details
                name="menuAction"
              ></v-select>
            </v-flex>

            <v-flex xs6>
              <v-select
                v-if="Form.menuLevel === '2'"
                v-model="Form.parent"
                :items="filterMenuByLevel('1')"
                item-text="alias"
                item-value="id"
                label="Parent"
                name="parent"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="Form.userLevel"
                v-validate="'required'"
                :items="lookupList('userlevel')"
                data-vv-rules="required"
                data-vv-scope="menuForm"
                :error-messages="errors.collect('menuForm.userLevel')"
                hide-details
                item-text="text"
                item-value="value"
                label="User Level*"
                name="userLevel"
              ></v-select>
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('menuForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    portallookups: {
      type: Array,
      default() {
        return [];
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portalmenus: {
      type: Array,
      default() {
        return [];
      }
    },
    menu: {
      type: Object,
      default() {
        return {};
      }
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      portalID: [],
      alias: null,
      icon: null,
      enabled: false,
      order: null,
      menu: null,
      menuLevel: null,
      userLevel: null,
      id: null
    },
    Menu: {}
  }),
  computed: {
    ...mapState({
      menuItems: state => state.Menu.Items
    }),
    ...mapGetters({
      lookupList: "portal/lookupList"
    }),
    // menus() {
    //   return this.$filter(this.portalmenus, { menu: "menus" });
    // },
    alias() {
      return this.$filter(this.portalmenus, { menus: "alias" });
    }
  },
  watch: {
    form() {
      this.Form = this.form;
    },
    menu() {
      this.Menu = this.menu;
    }
  },
  mounted() {},
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    refreshNavigation() {
      this.$store.dispatch("Menu/readMenu", [
        "menus",
        this.portal.id,
        "Menu/setMenu"
      ]);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          //console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Admin/createDocument", [
                "menus",
                this.Form,
                "Admin/setDocumentResult"
              ]);
              this.$store.dispatch("Menu/createMenuItem", [
                "menus",
                this.Form,
                this.Menu,
                "Menu/setMenu"
              ]);
              this.refreshNavigation();
              break;
            case "edit":
              var id = this.Form.id;
              //console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              //console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                "menus",
                id,
                this.Form
              ]);
              this.refreshNavigation();
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    },
    selectLookup: function(lookup) {
      return this.$filter(this.portallookups, {
        lookup: lookup
      });
    },
    filterMenuByLevel: function(menuLevel) {
      return this.$filter(this.menuItems, { menuLevel: menuLevel });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>

